<template>
  <v-card
    v-if="lead"
    class="mt-4 pa-4"
    border
  >
    <h4 class="mb-1 text-subtitle-2">
      {{ $t('lead.base-info.mail-info.title') }}
    </h4>

    <v-chip
      v-for="subscription in lead.subscriptions"
      :key="subscription.id"
      class="mt-2 mr-2"
      rounded
    >
      <v-icon
        v-if="subscription.unsubscribedAt"
        color="red"
        start
      >
        mdi-stop-circle
      </v-icon>
      <v-icon
        v-else-if="lead.confirmedAt"
        color="success"
        start
      >
        mdi-check-circle
      </v-icon>
      <v-icon
        v-else
        color="orange"
        start
      >
        mdi-clock
      </v-icon>
      {{ subscription.campaign.name }}
    </v-chip>
    <p v-if="!hasSubscriptionsOrChannel">
      {{ $t('lead.base-info.mail-info.no-subscriptions') }}
    </p>
    <div class="justify-end mt-6 d-flex ga-2">
      <Permission permission="lead:unsubscribe">
        <v-btn
          size="small"
          color="primary"
          :disabled="!hasSubscriptionsOrChannel || isLoading"
          @click.prevent="unsubscribe"
        >
          {{ $t('buttons.lead.mail-info.cta') }}
        </v-btn>
        <v-btn
          size="small"
          color="error"
          :disabled="!hasSubscriptionsOrChannel || isLoading"
          @click.prevent="stopAllCommunication"
        >
          {{ $t('buttons.lead.mail-info.stop-all-communication') }}
        </v-btn>
      </Permission>
    </div>
  </v-card>
</template>

<script>
import Permission from '@/components/Permission'
import bus, { eventNames } from '@/lib/eventBus'

import STOP_ALL_CAMPAIGNS_FOR_LEAD from './queries/StopAllCampaignsForLead.gql'
import STOP_ALL_COMMUNICATIONS_FOR_LEAD from './queries/StopAllCommunicationsForLead.gql'

export default {
  components: { Permission },
  props: {
    lead: { type: Object, default: null },
  },
  data() {
    return {
      isLoading: false,
    }
  },
  computed: {
    hasSubscriptionsOrChannel() {
      return Boolean(
        this.lead.subscriptions.filter(
          ({ subscribedAt, unsubscribedAt }) => subscribedAt && !unsubscribedAt
        ).length
      )
    },
  },
  methods: {
    async unsubscribe() {
      this.isLoading = true
      try {
        const { data } = await this.$apollo.mutate({
          mutation: STOP_ALL_CAMPAIGNS_FOR_LEAD,
          variables: {
            input: {
              leadId: this.lead.id,
            },
          },
        })
        this.$emit('unsubscribed')
        if (data.unsubscribeLead) {
          bus.$emit(eventNames.SHOW_SNACKBAR, {
            color: 'success',
            text: this.$t('alerts.lead.mail-info.success'),
          })
        } else {
          bus.$emit(eventNames.SHOW_SNACKBAR, {
            color: 'error',
            text: this.$t('alerts.lead.mail-info.error'),
          })
        }
      } catch (e) {
        bus.$emit(eventNames.SHOW_SNACKBAR, {
          color: 'error',
          text: this.$t('alerts.lead.mail-info.error'),
        })
      } finally {
        this.isLoading = false
      }
    },
    async stopAllCommunication() {
      this.isLoading = true
      try {
        await this.$apollo.mutate({
          mutation: STOP_ALL_COMMUNICATIONS_FOR_LEAD,
          variables: {
            input: {
              leadId: this.lead.id,
            },
          },
        })
        this.$emit('unsubscribed')
        bus.$emit(eventNames.SHOW_SNACKBAR, {
          color: 'success',
          text: this.$t('alerts.lead.mail-info.success-stop-all-communication'),
        })
      } catch (e) {
        bus.$emit(eventNames.SHOW_SNACKBAR, {
          color: 'error',
          text: this.$t('alerts.lead.mail-info.error-stop-all-communication'),
        })
      } finally {
        this.isLoading = false
      }
    },
  },
  emits: ['unsubscribed'],
}
</script>
